export default "/acfdf2704e412c85fb550b6408622629b62bf7b2/5860effcda061f4f05feb4a92be5a34c.svg";